<template>
  <Card class="trade-order">
    <template slot="header">
      <div class="header flex align-center">
        <a class="pointer title mar-r5"> <span>采购订单</span> </a>
        <div class="pointer flex items-center" v-if="!purchaseAuthority">
          <el-tooltip placement="bottom" effect="dark" content="抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限">
            <i class="el-icon-warning-outline gray6 f18 mar5-l"></i>
          </el-tooltip>
        </div>
      </div>
    </template>
    <div class="items">
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}v/order/list?appid=1&tabId=1&isShowTitle=1`, '待我支付-我的订单', 0, purchaseAuthority)">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.dzfOrderNum || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待我支付</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}v/order/list?appid=1&tabId=2&isShowTitle=1`, '待商家发货-我的订单', 0, purchaseAuthority)">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.orderStatus2 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待商家发货</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}v/order/list?appid=1&tabId=3&isShowTitle=1`, '待我确认-我的订单', 0, purchaseAuthority)">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.orderStatus3 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待我确认</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}v/order/list?appid=1&tabId=4&isShowTitle=1`, '待我评价-我的订单', 0, purchaseAuthority)">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.orderStatus4 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待我评价</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}v/order/list?appid=1&tabId=5&isShowTitle=1`, '已完成订单-我的订单', 0, purchaseAuthority)">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.orderStatus5 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>已完成订单</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}v/aftersales/orderList?appid=1&isShowTitle=1`, '售后订单-我的订单', 0, purchaseAuthority)">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.refundStatusCount || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>售后订单</span>
      </a>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "../../index.scss";
</style>

<script>
import { mapState } from "vuex";
import Card from "@/components/Card";

export default {
  components: {
    Card,
  },

  computed: mapState({
    userIdentity: (state) => state.app.userIdentity,
    purchaseAuthority: (state) => state.app.purchaseAuthority,
  }),

  data() {
    return {
      origin: process.env,
      orderInfo: {},
    };
  },

  mounted() {
    console.log("采购订单", this.purchaseAuthority, this.userIdentity);
    if (this.purchaseAuthority) {
      const { ID } = this.userIdentity;
      this.$store
        .dispatch("trade/orderNumsList", {
          orgId: ID,
        })
        .then((data) => {
          this.orderInfo = data;
        });
    }
  },
};
</script>
